import React from "react";
import { motion } from "motion/react";

interface Props {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
}

export const SessionItemFadeInAnimation: React.FC<Props> = ({
  children,
  delay = 0,
  duration = 0.2,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        opacity: {
          duration,
          delay,
          ease: "easeOut",
        },
        layout: {
          duration: 0.2,
          ease: "easeInOut",
        },
      }}
    >
      {children}
    </motion.div>
  );
};
